import axios from 'axios';
import { API_URL } from './appData';


const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  transformRequest: [(data, headers) => {
    if (data instanceof FormData) {
      return data;
    }
    return JSON.stringify(data);
  }]
});

// Add token to requests if available

const clearToken = () => {
    localStorage.removeItem('token');
    localStorage.clear();
    delete api.defaults.headers.Authorization;
};

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      window.location.href = '../';
    } else if (error.response?.status === 406) {
      clearToken();
    }
    return Promise.reject(error);
  }
);

// API methods
//export const getMessages = (userId) => api.get(`/messages/list/${userId}`);

export default api;